// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"FileUploadModal_mainContainer__mkeOw","contentDiv":"FileUploadModal_contentDiv__MiKDu","fullWidth":"FileUploadModal_fullWidth__2rpB0"};